import React, { useState, useEffect, useMemo } from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogContentText from "@material-ui/core/DialogContentText";
import { withStyles } from "@material-ui/core/styles";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import { Typography, DialogTitle, makeStyles } from "@material-ui/core";
import { Grid, Box, Paper } from "@material-ui/core";
import Controls from "../controls/Controls";
import MUIDataTable from "mui-datatables";
import getMuiTheme from "../assets/muitheme";
import { ThemeProvider } from "@material-ui/core/styles";
import Divider from "@material-ui/core/Divider";
import { getExternalPbmsForList } from "../services/PerksServices";
import PerksPageLoader from "../components/PerksPageLoader";
import AddButton from "../components/AddButton";
import SelectExternalPBM from "./SelectExternalPBM";
import PerksTooltip from "../components/PerksTooltip.js";
import { useForm, Form } from "../controls/useForm";
import { editExternalPbmList } from "../services/PerksServices";
import { inactivateexternalpbmlink } from "../services/PerksServices";
import { toast } from "react-toastify";
import EditPBMToList from "./EditPBMToList";
import Tooltip from "@material-ui/core/Tooltip";
import Button from "@material-ui/core/Button";
import EditIcon from "@mui/icons-material/Edit";
import SearchIcon from "@mui/icons-material/Search";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import settingsGear from "../assets/UHG_Operations_Navy.png";
import { formatDate } from "../utils/perksutil";

const LightTooltip = withStyles(theme => ({
  tooltip: {
    backgroundColor: theme.palette.common.white,
    color: "#316BBE",
    boxShadow: theme.shadows[1],
    fontSize: 11,
    padding: 10,
    margin: 10
  },
  arrow: {
    color: theme.palette.common.white
  }
}))(Tooltip);

// Removed v5 styled BootstrapDialog and BootstrapDialogTitle to avoid version mixing

const useStyles = makeStyles(theme => ({
  dialogWrapper: {
    padding: theme.spacing(1),
    position: "absolute",
    top: theme.spacing(5)
  },
  dialogTitle: {
    paddingRight: "10px",
    color: "#002677"
  }
}));

export default function EditExternalPBMList(props) {
  const classes = useStyles();
  const theme = useMemo(() => getMuiTheme(), []);
  const [displayPbmListData, setDisplayPbmListData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [refreshListData, setRefreshListData] = useState(false);
  const [showAddPBMDialogPage, setShowAddPBMDialogPage] = useState(false);
  const [enableSubmit, setEnableSubmit] = useState(true);
  const [loading, setLoading] = useState(false);
  const { onClose, open, onSubmit, refresh, closeOnUpdate } = props;
  const [currentlySelectedRow, setCurrentlySelectedRow] = useState([]);
  const [showEditPBMListDialogPage, setShowEditPBMListDialogPage] = useState(
    false
  );
  const toasterConfig = {
    position: "top-right",
    autoClose: 2000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true
  };

  const columns = [
    {
      name: " ",
      options: {
        filter: false,
        sort: false,
        empty: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <LightTooltip
              arrow
              interactive
              placement="right"
              title={(() => {
                const isInactive = Array.isArray(tableMeta.rowData) && tableMeta.rowData[5] === "I";
                return (
                  <>
                    <div
                      onClick={() => handleEditClick(tableMeta.rowData)}
                      onMouseOver={changeBGColor}
                      onMouseLeave={revertBGColor}
                      style={{
                        fontSize: "16px",
                        fontFamily: "OptumSansBold",
                        cursor: "pointer",
                        marginLeft: "2px",
                        marginRight: "2px"
                      }}
                    >
                      <EditIcon style={{ height: "0.8em", width: "0.8em" }} />{" "}
                      &nbsp;&nbsp;EDIT
                    </div>

                    <br></br>

                    <div
                      onClick={!isInactive ? () => handleInactivateClick(tableMeta.rowData) : undefined}
                      onMouseOver={!isInactive ? changeBGColor : undefined}
                      onMouseLeave={!isInactive ? revertBGColor : undefined}
                      style={{
                        fontSize: "16px",
                        fontFamily: "OptumSansBold",
                        cursor: isInactive ? "not-allowed" : "pointer",
                        marginLeft: "2px",
                        marginRight: "2px",
                        opacity: isInactive ? 0.5 : 1
                      }}
                      title={isInactive ? "Already inactive" : ""}
                    >
                      <VisibilityOffIcon
                        style={{ height: "0.8em", width: "0.8em" }}
                      />{" "}
                      &nbsp;&nbsp;INACTIVATE&nbsp;&nbsp;
                    </div>
                  </>
                );
              })()}
            >
              <img
                width="30px"
                height="27px"
                src={settingsGear}
                alt="settings gear"
              />
            </LightTooltip>
          );
        }
      }
    },
    {
      name: "xp2ExtPbmID",
      label: "Ext PBM ID",
      options: {
        filter: false,
        sort: true,
        sortThirdClickReset: true
      }
    },
    {
      name: "xp2ExtPBMName",
      label: "Ext PBM Name",
      options: {
        filter: false,
        sort: true,
        sortThirdClickReset: true
      }
    },
    {
      name: "fromDate",
      label: "From Date",
      options: {
        filter: false,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return value && formatDate(value);
        }
      }
    },

    {
      name: "thruDate",
      label: "Thru Date",
      options: {
        filter: false,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return value && formatDate(value);
        }
      }
    },
    {
      name: "status",
      label: "Status",
      options: {
        filter: true,
        sort: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          return value && value === "A" ? "Active" : "Inactive";
        }
      }
    },
    {
      name: "addDate",
      label: "Add Date",
      options: {
        filter: false,
        sort: false
      }
    },
    {
      name: "changeDate",
      label: "Change Date",
      options: {
        filter: false,
        sort: false
      }
    },
    {
      name: "changeUser",
      label: "User",
      options: {
        filter: false,
        sort: false
      }
    },
    {
      name: "xp4SeqNbr",
      label: "Sequence Number",
      options: {
        filter: false,
        sort: false,
        display: false
      }
    }
  ];

  const handleEditClick = rowData => {
    console.log("handle edit click " + rowData);
    setShowEditPBMListDialogPage(true);
    setCurrentlySelectedRow(rowData);
  };

  const handleViewClick = rowData => {
    console.log("handle view click " + rowData);
  };

  const changeBGColor = e => {
    e.target.style.background = "rgb(245,245,245)";
  };

  const revertBGColor = e => {
    e.target.style.background = "white";
  };

  const getSessionUser = () => {
    const raw = sessionStorage.getItem("user-name");
    if (!raw || raw.trim() === "" || raw === "undefined" || raw === "null") return "PerksUser";
    try {
      const parsed = JSON.parse(raw);
      return typeof parsed === "string" && parsed.trim() !== "" ? parsed : "PerksUser";
    } catch (e) {
      return raw.trim() !== "" ? raw : "PerksUser";
    }
  };

  const initialFValues = {
    extPBMListId: props.pbmRowData[1].trim(),
    extPBMListName: props.pbmRowData[2].trim(),
    extPBMListType: (props.pbmRowData[3] || "").toString().trim(),
    addUser: props.pbmRowData[5].trim(),
    addProgram: props.pbmRowData[6],
    changeUser: getSessionUser(),
    changeProgram: "Perks"
  };

  const data = {
    pbmListId: ""
  };

  const handleChange = e => {
    e.preventDefault();
    if (validate()) {
      setLoading(true);
      console.log("values object" + values);
      const extPBMListToUpdate = {
        pbmListId: values.extPBMListId,
        pbmListName: values.extPBMListName,
        pbmListType: values.extPBMListType,
        addUser: values.addUser,
        addProgram: values.addProgram,
        changeUser: values.changeUser,
        changeProgram: values.changeProgram
      };

      console.log("About to Edit PBM List" + extPBMListToUpdate.fromDate);
      editExternalPbmList(extPBMListToUpdate).then(function(axiosResult) {
        console.log("axios result from Edit External Pbm " + axiosResult);
        if (axiosResult !== null && axiosResult.data !== null) {
          console.log("Update PBM response.JSON:", {
            message: "Post successful",
            data: axiosResult
          });
          setLoading(false);
          // Immediately reflect updated field values in the form UI
          setValues(prev => ({
            ...prev,
            extPBMListName: extPBMListToUpdate.pbmListName,
            extPBMListType: extPBMListToUpdate.pbmListType
          }));
          // Trigger local refresh to re-fetch latest data from backend
          setRefreshListData(true);
          // Optionally close dialog after successful update (default: close)
          if (closeOnUpdate !== false && typeof onClose === "function") onClose();
          // Notify parent to refresh, if provided
          if (typeof refresh === "function") {
            refresh();
          }
          if (typeof onSubmit === "function") {
            onSubmit();
          }
          toast.success(
            `External PBM List ${extPBMListToUpdate.pbmListId} updated Successfully`,
            toasterConfig
          );
        } else {
          setLoading(false);
          toast.error("Error while updating External PBM List", toasterConfig);
        }
      });
    }
  };

  const handleInactivateClick = rowData => {
    console.log("handle interactive click " + rowData);
    //e.preventDefault();

    setLoading(true);
    console.log("values object" + values);
    const extPBMListDetail = {
      xp1ExtPbmList: initialFValues.extPBMListId,
      xp2ExtPbmID: rowData[1],
      xp4SeqNbr: "99999",
      fromDate: rowData[3],
      thruDate: rowData[4],
      status: "I",
      addUser: getSessionUser(),
      addProgram: "Perks",
      changeUser: getSessionUser(),
      changeProgram: "Perks"
    };
    console.log("Here");
    console.log(extPBMListDetail);
    console.log(
      "About to Inactive PBM List Detail" + extPBMListDetail.xp2ExtPbmID
    );
    inactivateexternalpbmlink(extPBMListDetail).then(function(axiosResult) {
      console.log("axios result from Edit External Pbm " + axiosResult);
      if (axiosResult !== null && axiosResult.data !== null) {
        console.log("Update PBM response.JSON:", {
          message: "Post successful",
          data: axiosResult
        });
        setLoading(false);
        // Optimistically update the local table to reflect inactive status
        setDisplayPbmListData(prev =>
          Array.isArray(prev)
            ? prev.map(item =>
                item && item.xp2ExtPbmID === extPBMListDetail.xp2ExtPbmID
                  ? {
                      ...item,
                      status: "I",
                      changeUser: getSessionUser(),
                      changeDate: new Date().toISOString()
                    }
                  : item
              )
            : prev
        );
        // Trigger a refresh from backend to ensure data is in sync
        setRefreshListData(true);
        //onSubmit();
        toast.success(
          `External PBM Id ${extPBMListDetail.xp2ExtPbmID} Inactivated Successfully`,
          toasterConfig
        );
      } else {
        setLoading(false);
        toast.error("Error while inactivating External PBM Id", toasterConfig);
      }
    });
  };

  const validate = (fieldValues = values) => {
    // Validate against the latest values (merge partial changes into current state)
    const src = fieldValues === values ? values : { ...values, ...fieldValues };
    const temp = { ...errors };

    // Always compute both errors so enable state is accurate even on partial edits
    temp.extPBMListName = src.extPBMListName ? "" : "This field is required.";
    const v = (src.extPBMListType || "").toString().trim();
    temp.extPBMListType = v === "1" || v === "2" ? "" : "Enter 1 or 2 only.";

    setErrors({ ...temp });

    const isValid = temp.extPBMListName === "" && temp.extPBMListType === "";
    setEnableSubmit(isValid);

    if (fieldValues === values) return isValid;
  };

  const { values, setValues, errors, setErrors, handleInputChange } = useForm(
    initialFValues,
    true,
    validate
  );

  // Keep form values in sync with latest selected row when dialog reopens
  useEffect(() => {
    if (Array.isArray(props.pbmRowData) && props.pbmRowData.length) {
      setValues(prev => ({
        ...prev,
        extPBMListId: (props.pbmRowData[1] || prev.extPBMListId)?.toString().trim(),
        extPBMListName: (props.pbmRowData[2] || prev.extPBMListName)?.toString().trim(),
        extPBMListType: ((props.pbmRowData[3] ?? prev.extPBMListType) || "")?.toString().trim(),
        addUser: (props.pbmRowData[5] || prev.addUser)?.toString().trim(),
        addProgram: props.pbmRowData[6] ?? prev.addProgram
      }));
    }
  }, [props.pbmRowData]);

  // On reopen, ensure fields are re-synced from the selected row
  useEffect(() => {
    if (open && Array.isArray(props.pbmRowData) && props.pbmRowData.length) {
      setValues(prev => ({
        ...prev,
        extPBMListId: (props.pbmRowData[1] || prev.extPBMListId)?.toString().trim(),
        extPBMListName: (props.pbmRowData[2] || prev.extPBMListName)?.toString().trim(),
        extPBMListType: ((props.pbmRowData[3] ?? prev.extPBMListType) || "")?.toString().trim(),
        addUser: (props.pbmRowData[5] || prev.addUser)?.toString().trim(),
        addProgram: props.pbmRowData[6] ?? prev.addProgram
      }));
    }
  }, [open]);

  const options = {
    selectableRows: "multiple",
    selectableRowsHeader: true,
    selectToolbarPlacement: "replace",
    resizeableColumns: true,
    download: true,
    print: false,
    filterable: false,
    filter: true,
    search: true,
    pagination: true,
    viewColumns: true,
    filterType: "multiselect",
    responsive: "vertical",
    expandableRows: false,
    rowsPerPage: 10,
    rowsPerPageOptions: [10, 25, 50],
    jumpToPage: true,
    customToolbarSelect: () => {},
    textLabels: {
      pagination: {
        next: "Next >",
        previous: "< Previous",
        rowsPerPage: "Total rows Per Page"
      },
      body: {
        noMatch: isLoading ? (
          <PerksPageLoader isLoading />
        ) : (
          "No External PBM List data to display"
        )
      }
    }
  };

  useEffect(() => {
    console.log("setting external Pbm List on load");
    data.pbmListId = initialFValues.extPBMListId;
    setIsLoading(true);
    getExternalPbmsForList(data).then(function(axiosResult) {
      console.log("response.JSON:", {
        message: "Request received",
        data: axiosResult.data
      });
      setDisplayPbmListData(axiosResult.data);
      setRefreshListData(false);
      setIsLoading(false);
    });
    console.log("data from service call " + displayPbmListData);
  }, [refreshListData]);

  const handleEditPBM = () => {
    setRefreshListData(true);
  };

  const handleAddButtonIconClick = () => {
    setShowAddPBMDialogPage(true);
    console.log("handle edit pbm list dialog Button " + showAddPBMDialogPage);
  };

  const handleClose = () => {
    setShowAddPBMDialogPage(false);
    // setRefreshListData(true);
  };

  const handleAddPBM = () => {
    setShowAddPBMDialogPage(false);
    setRefreshListData(true);
  };

  const handleCloseEdit = () => {
    setShowEditPBMListDialogPage(false);
  };

  return isLoading ? (
    <PerksPageLoader show={isLoading} />
  ) : (
    <Dialog
      fullWidth
      maxWidth="lg"
      open={true}
      PaperProps={{ variant: "elevation14" }}
    >
      <DialogTitle className={classes.dialogTitle}>
        <div style={{ display: "flex" }}>
          <Typography variant="h6" component="div" style={{ flexGrow: 5 }}>
            External PBM List Detail
          </Typography>
        </div>
      </DialogTitle>

      <Divider style={{ width: "100%" }} />

      <Form onSubmit={handleChange} id="externPBMListForm">
        <Grid container spacing={1} justify="center">
          <Grid item xs={8}>
            <Grid
              item
              justify="center"
              alignItems="center"
              style={{
                marginTop: "10px",
                marginBottom: "2px"
              }}
            >
              <DialogContentText className={classes.dialogTitle}>
                <Grid container spacing={2} justify="center" alignItems="center">
                  <Grid item xs={3}>
                    <Grid item xs={12}>
                      <Controls.Input
                        name="extPBMListId"
                        label="Ext PBM List ID"
                        value={values.extPBMListId}
                        fullWidth
                        style={{ width: "100%" }}
                        disabled
                      />
                    </Grid>
                  </Grid>

                  <Grid item xs={5}>
                    <Grid item xs={12}>
                      <Controls.Input
                        name="extPBMListName"
                        label="Ext PBM List Name*"
                        value={values.extPBMListName}
                        inputProps={{
                          maxLength: 25
                        }}
                        fullWidth
                        style={{ width: "100%" }}
                        onChange={handleInputChange}
                        error={errors.extPBMListName}
                      />
                    </Grid>
                  </Grid>
                  <Grid item xs={3}>
                    <Grid item xs={12}>
                      <Controls.Input
                        name="extPBMListType"
                        label="Ext PBM List Type (1 or 2)*"
                        value={values.extPBMListType}
                        inputProps={{
                          maxLength: 1,
                          inputMode: "numeric",
                          pattern: "[12]"
                        }}
                        fullWidth
                        style={{ width: "100%" }}
                        onChange={handleInputChange}
                        error={errors.extPBMListType}
                      />
                    </Grid>
                  </Grid>
                </Grid>
              </DialogContentText>

              <Grid container spacing={1} justify="center" style={{ marginTop: "2px", marginBottom: "2px" }}>
                <DialogActions style={{ width: '100%', justifyContent: 'center', display: 'flex', columnGap: 16 }}>
                  <Controls.Button
                    text="UPDATE"
                    color="default"
                    type="Submit"
                    disabled={!enableSubmit}
                  />
                  <Controls.Button
                    text="CANCEL"
                    color="default"
                    onClick={() => onClose()}
                  />
                  <PerksPageLoader show={loading} />
                </DialogActions>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Form>

      <Divider style={{ width: "100%" }} />

      <Grid container alignItems="center">
        <Grid
          item
          xs={2}
          justify="center"
          alignItems="center"
          style={{
            marginLeft: "87%",
            marginTop: "5px",
            marginBottom: "10px"
          }}
        >
          <AddButton
            className="addButtonText"
            clickHandler={handleAddButtonIconClick}
            name="Add PBM"
          />
        </Grid>
      </Grid>

      <div style={{ marginLeft: "40px" }}>
        <ThemeProvider theme={theme}>
          <MUIDataTable
            title="External PBM List"
            data={displayPbmListData}
            columns={columns}
            options={options}
          />
        </ThemeProvider>
        {showAddPBMDialogPage && (
          <SelectExternalPBM
            listId={initialFValues.extPBMListId}
            handleClose={handleClose}
            refresh={handleAddPBM}
            
          />
        )}
        {showEditPBMListDialogPage && (
          <EditPBMToList
            pbmRowData={currentlySelectedRow}
            addListId={initialFValues.extPBMListId}
            onClose={handleCloseEdit}
            refresh={handleEditPBM}
          />
        )}
      </div>

      <br></br>
    </Dialog>
  );
}
